/**
 * @param {unknown} source
 * @returns {string}
 */
export function resolveUnitId(source) {
  if (source == null || typeof source !== 'object') {
    return '';
  }
  return String(
    source.id
    ?? source.unitId
    ?? source.unit?.id
    ?? '',
  ).trim();
}
